import React, { useState, useEffect } from "react";
import { Button, Row, Col } from "react-bootstrap";
import "./style.css";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import qs from "query-string";
const reg =
  /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
const Forgotpassword = (props) => {
  const [selectedTab, setSelectedTab] = useState("sendOtp");
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confPassword, setConfPassword] = useState("");
  const [errors, setErrors] = useState({
    email: "",
    otp: "",
    password: "",
    confPassword: "",
  });

  useEffect(() => {
    console.log("this.props", props);
  }, []);

  let sendOtpHandler = (e) => {
    const { history } = props;
    e.preventDefault();
    if (!validate()) {
      props.sendOtpForgotPassword({ email: email });
    }
  };

  useEffect(() => {
    const {
      location: { search },
    } = props;
    if (search) {
      let query = qs.parse(search);
      console.log("tab is", query["tab"]);
      if (query && query["tab"] && selectedTab !== query["tab"]) {
        setSelectedTab(query["tab"]);
      }
    }
  }, [props.location.search]);

  const verifyOtpHandler = (e) => {
    e.preventDefault();
    if (!validate()) {
      props.otpVerifyForgotPassword({
        email: email || (props.location.state && props.location.state.email),
        otp: otp,
      });

      console.log("email", props.location.state && props.location.state.email);
    }
  };

  const resetPasswordHandler = (e) => {
    e.preventDefault();
    if (!validate()) {
      props.reSetNewpassword({
        email: email || (props.location.state && props.location.state.email),
        password: password,
        otp: otp,
      });
      // setSelectedTab("sendOtp");
    }
  };

  const renderMessage = (tab) => {
    switch (tab) {
      case "sendOtp":
        return "Enter your email and we'll send you OTP to reset your password .";
      case "verifyOtp":
        return "Enter the OTP you received";
      case "resetPass":
        return "Reset your password here";
      default:
        return "Enter your email and we'll send you OTP to reset your password .";
    }
  };

  const validate = () => {
    let isError = false;
    let errorMessage = {
      email: "",
      otp: "",
      password: "",
      confPassword: "",
    };
    if (selectedTab === "sendOtp") {
      if (!email.trim().length) {
        isError = true;
        errorMessage.email = "Email is required";
      } else if (!reg.test(email)) {
        isError = true;
        errorMessage.email = "Enter a valid email";
      }
    } else if (selectedTab === "verifyOtp") {
      if (!otp.trim().length) {
        isError = true;
        errorMessage.otp = "Please enter the received OTP";
      }
    } else if (selectedTab === "resetPass") {
      if (!password.trim().length) {
        isError = true;
        errorMessage.password = "Password is required";
      } else if (password.length < 6) {
        isError = true;
        errorMessage.password = " Password must contain atleast 6 characters";
      }
      if (selectedTab === "resetPass") {
        if (!confPassword.trim().length) {
          isError = true;
          errorMessage.confPassword = "Confirm password is required";
        } else if (password && confPassword && confPassword !== password) {
          isError = true;
          errorMessage.confPassword = "Password does not match";
        }
      }
    }

    setErrors(errorMessage);
    return isError;
  };

  const resendOtpforResetPwd = () => {
    props.reSendOtpForgotPassword({
      email: email || (props.location.state && props.location.state.email),
    });
  };
  return (
    <div>
      <div className="fogot-backGround">
        <Row>
          <Col xs={12} md={6} sm={12} lg={6}>
            <img
              className="fogot-backGround-image"
              src={require("../../assets/img/login-image.png")}
              alt=""
            />
          </Col>
          <Col xs={12} md={6} sm={12} lg={6}>
            <div className="forgot-body">
              <div>
                <img
                  className="forgot-logo-image "
                  src={require("../../assets/img/logisrannurLogo.png")}
                />
              </div>
              <div>
                <h3 className="forgot-title">Forgot Your Password?</h3>
              </div>

              <div>
                <p className="forgot-p">{renderMessage(selectedTab)}</p>
              </div>

              <div className="loginForm">
                <Form className="loginform">
                  {selectedTab === "resetPass" ? (
                    <>
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Form.Group>
                            <Form.Control
                              type="password"
                              name="password"
                              value={password}
                              onChange={(e) => {
                                setPassword(e.target.value);
                                setErrors({
                                  ...errors,
                                  password: "",
                                });
                              }}
                              placeholder="Enter the new password"
                            />
                            <div className="frgterrStyle">
                              {errors.password}
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                      <br />
                      <Row>
                        <Col lg={12} md={12} sm={12} xs={12}>
                          <Form.Group>
                            <Form.Control
                              type="password"
                              name="confPassword"
                              value={confPassword}
                              onChange={(e) => {
                                setConfPassword(e.target.value);
                                setErrors({
                                  ...errors,
                                  confPassword: "",
                                });
                              }}
                              placeholder="Re-enter the password"
                            />
                            <div className="frgterrStyle">
                              {errors.confPassword}
                            </div>
                          </Form.Group>
                        </Col>
                      </Row>
                    </>
                  ) : selectedTab === "verifyOtp" ? (
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Form.Group>
                          <Form.Control
                            type="text"
                            name="otp"
                            value={otp}
                            onChange={(e) => {
                              setOtp(e.target.value);
                              setErrors({
                                ...errors,
                                otp: "",
                              });
                            }}
                            placeholder="Enter the OTP"
                          />
                          {errors.otp && (
                            <div className="frgterrStyle">
                              <span>{errors.otp}</span>
                            </div>
                          )}
                          <Button
                            className="alignStyle"
                            variant="link"
                            onClick={resendOtpforResetPwd}
                          >
                            Resend OTP
                          </Button>
                        </Form.Group>
                      </Col>
                    </Row>
                  ) : (
                    <Row>
                      <Col lg={12} md={12} sm={12} xs={12}>
                        <Form.Group controlId="formGroupEmail">
                          <Form.Control
                            type="text"
                            name="forgotMobNo"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              setErrors({
                                ...errors,
                                email: "",
                              });
                            }}
                            placeholder="Enter your email"
                          />
                          <div className="frgterrStyle">{errors.email}</div>
                        </Form.Group>
                      </Col>
                    </Row>
                  )}
                  <br />
                  <Row>
                    <Col xs={12} md={9} sm={12} lg={9}>
                      {selectedTab === "verifyOtp" ? (
                        <Button
                          className="forgot-contactpagebtn"
                          type="submit"
                          onClick={(e) => verifyOtpHandler(e)}
                        >
                          VERIFY OTP
                        </Button>
                      ) : selectedTab === "resetPass" ? (
                        <Button
                          className="forgot-contactpagebtn"
                          type="submit"
                          onClick={(e) => resetPasswordHandler(e)}
                        >
                          SUBMIT
                        </Button>
                      ) : (
                        <Button
                          className="forgot-contactpagebtn"
                          onClick={(e) => sendOtpHandler(e)}
                        >
                          SEND OTP
                        </Button>
                      )}
                    </Col>
                  </Row>
                  <div className="forgotPswddiv" className="forgotPswddiv">
                    <Col xs={12} md={12} sm={12} lg={12}>
                      <Link to="/login">Back to login</Link>
                    </Col>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
export default Forgotpassword;
